export const GET_LAST_NOTIFICATION: '@global/GET_LAST_NOTIFICATION' =
  '@global/GET_LAST_NOTIFICATION';
export const SET_LAST_NOTIFICATION: '@global/SET_LAST_NOTIFICATION' =
  '@global/SET_LAST_NOTIFICATION';
export const GET_LAST_NOTIFICATION_FAILED: '@global/GET_LAST_NOTIFICATION_FAILED' =
  '@global/GET_LAST_NOTIFICATION_FAILED';
export const SET_NOTIFICATION_READ: '@global/SET_NOTIFICATION_READ' =
  '@global/SET_NOTIFICATION_READ';
export const SET_NOTIFICATION_READ_SUCCESS: '@global/SET_NOTIFICATION_READ_SUCCESS' =
  '@global/SET_NOTIFICATION_READ_SUCCESS';
export const SET_NOTIFICATION_READ_FAILED: '@global/SET_NOTIFICATION_READ_FAILED' =
  '@global/SET_NOTIFICATION_READ_FAILED';
export const SET_AUTO_DETAILS_PAGE_BREADCRUMBS_PATH: '@global/SET_AUTO_DETAILS_PAGE_BREADCRUMBS_PATH' =
  '@global/SET_AUTO_DETAILS_PAGE_BREADCRUMBS_PATH';
export const SET_MRH_DETAILS_PAGE_BREADCRUMBS_PATH: '@global/SET_MRH_DETAILS_PAGE_BREADCRUMBS_PATH' =
  '@global/SET_MRH_DETAILS_PAGE_BREADCRUMBS_PATH';
export const SET_EPARGN_DETAILS_PAGE_BREADCRUMBS_PATH: '@global/SET_EPARGN_DETAILS_PAGE_BREADCRUMBS_PATH' =
  '@global/SET_EPARGN_DETAILS_PAGE_BREADCRUMBS_PATH';
export const GET_VIMEO_THUMBNAIL_SRC: '@global/GET_VIMEO_THUMBNAIL_SRC' =
  '@global/GET_VIMEO_THUMBNAIL_SRC';
export const GET_VIMEO_THUMBNAIL_SRC_SUCCESS: '@global/GET_VIMEO_THUMBNAIL_SRC_SUCCESS' =
  '@global/GET_VIMEO_THUMBNAIL_SRC_SUCCESS';
export const GET_VIMEO_THUMBNAIL_SRC_FAILED: '@global/GET_VIMEO_THUMBNAIL_SRC_FAILED' =
  '@global/GET_VIMEO_THUMBNAIL_SRC_FAILED';
export const SET_TABS: '@global/SET_TABS' = '@global/SET_TABS';
export const SET_TOASTER_OPEN: '@global/SET_TOASTER_OPEN' =
  '@global/SET_TOASTER_OPEN';
export const SET_TOASTER_CLOSE: '@global/SET_TOASTER_CLOSE' =
  '@global/SET_TOASTER_CLOSE';
export const OPEN_MODAL_SERVICES_AUTO: '@global/OPEN_MODAL_SERVICES_AUTO' =
  '@global/OPEN_MODAL_SERVICES_AUTO';
export const CLOSE_MODAL_SERVICES_AUTO: '@global/CLOSE_MODAL_SERVICES_AUTO' =
  '@global/CLOSE_MODAL_SERVICES_AUTO';
export const OPEN_MODAL_SERVICES_MRH: '@global/OPEN_MODAL_SERVICES_MRH' =
  '@global/OPEN_MODAL_SERVICES_MRH';
export const CLOSE_MODAL_SERVICES_MRH: '@global/CLOSE_MODAL_SERVICES_MRH' =
  '@global/CLOSE_MODAL_SERVICES_MRH';
export const SET_SELECTED_TAB: '@global/SET_SELECTED_TAB' =
  '@global/SET_SELECTED_TAB';
export const GET_FAQ: '@global/GET_FAQ' = '@global/GET_FAQ';
export const SET_FAQ: '@global/SET_FAQ' = '@global/SET_FAQ';
export const SET_FAQ_SEARCHED: '@global/SET_FAQ_SEARCHED' =
  '@global/SET_FAQ_SEARCHED';
export const GET_FAQ_FAILED: '@global/GET_FAQ_FAILED' =
  '@global/GET_FAQ_FAILED';
export const REPORT_BUG: '@global/REPORT_BUG' = '@global/REPORT_BUG';
export const REPORT_BUG_SUCCESS: '@global/REPORT_BUG_SUCCESS' =
  '@global/REPORT_BUG_SUCCESS';
export const REPORT_BUG_FAIL: '@global/REPORT_BUG_FAIL' =
  '@global/REPORT_BUG_FAIL';

export const GET_LOCATIONS: '@global/GET_LOCATIONS' = '@global/GET_LOCATIONS';
export const GET_LOCATIONS_SUCCESS: '@global/GET_LOCATIONS_SUCCESS' =
  '@global/GET_LOCATIONS_SUCCESS';
export const GET_LOCATIONS_FAILURE: '@global/GET_LOCATIONS_FAILURE' =
  '@global/GET_LOCATIONS_FAILURE';
export const GET_CONTACTS: '@global/GET_CONTACTS' = '@global/GET_CONTACTS';
export const GET_CONTACTS_SUCCESS: '@global/GET_CONTACTS_SUCCESS' =
  '@global/GET_CONTACTS_SUCCESS';
export const GET_CONTACTS_FAILURE: '@global/GET_CONTACTS_FAILURE' =
  '@global/GET_CONTACTS_FAILURE';
export const SET_SELECTED_FAQ: '@global/SET_SELECTED_FAQ' =
  '@global/SET_SELECTED_FAQ';

export const SET_AMC_DETAILS_PAGE_BREADCRUMBS_PATH: '@global/SET_AMC_DETAILS_PAGE_BREADCRUMBS_PATH' =
  '@global/SET_AMC_DETAILS_PAGE_BREADCRUMBS_PATH';
export const SET_ASI_DETAILS_PAGE_BREADCRUMBS_PATH: '@global/SET_ASI_DETAILS_PAGE_BREADCRUMBS_PATH' =
  '@global/SET_ASI_DETAILS_PAGE_BREADCRUMBS_PATH';
